import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAuth } from '@strongio/pretrained-dashboard/auth';
import { Form, FormField } from '@strongio/pretrained-dashboard/form';
import LinkTo from '@strongio/pretrained-dashboard/components/LinkTo';
import ErrorAlert from '@strongio/pretrained-dashboard/components/ErrorAlert';

export default function LoginForm({ authComplete }) {
  const { isAuthenticated } = useAuth();
  const t = useTranslations('login');
  const [apiError, setApiError] = useState(null);
  const [loading, setLoading] = useState(false);

  const router = useRouter();

  useEffect(() => {
    if (isAuthenticated()) {
      const url = new URL(router.query.next || '/', window.location.href);
      router.push(url);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  const onSubmit = async (value) => {
    setApiError(null);
    setLoading(true);
    axios.post('/api/user/authenticate', value).
    then((response) => authComplete(response.data)).
    catch((e) => setApiError(e)).
    finally(() => setLoading(false));
  };

  return /*#__PURE__*/(
    React.createElement(Form, { onSubmit: onSubmit, className: "space-y-4" },
    apiError && /*#__PURE__*/React.createElement(ErrorAlert, { error: apiError }), /*#__PURE__*/

    React.createElement(FormField, { name: "email", type: "email", label: t('email'), required: true },
    ({ errors, label, ...props }) => /*#__PURE__*/
    React.createElement("div", null, /*#__PURE__*/
    React.createElement("label", {
      htmlFor: "name",
      className: "block text-sm font-medium text-gray-700" },

    label), /*#__PURE__*/

    React.createElement("input", Object.assign({
      id: "email",
      type: "text",
      autoComplete: "email" },
    props, {
      className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" })),

    errors && /*#__PURE__*/React.createElement("p", { className: "text-xs mt-1.5 text-red-600" }, errors.message))), /*#__PURE__*/




    React.createElement(FormField, {
      name: "password",
      type: "password",
      label: t('password'),
      required: true },

    ({ errors, label, ...props }) => /*#__PURE__*/
    React.createElement("div", null, /*#__PURE__*/
    React.createElement("label", {
      htmlFor: "password",
      className: "block text-sm font-medium text-gray-700" },

    label), /*#__PURE__*/

    React.createElement("input", Object.assign({
      id: "password",
      type: "password",
      autoComplete: "current-password" },
    props, {
      className: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" })),

    errors && /*#__PURE__*/React.createElement("p", { className: "text-xs mt-1.5 text-red-600" }, errors.message))), /*#__PURE__*/




    React.createElement("div", { className: "flex items-center" }, /*#__PURE__*/
    React.createElement("div", { className: "text-sm" }, /*#__PURE__*/
    React.createElement(LinkTo, {
      href: "/forget",
      className: "font-medium text-indigo-600 hover:text-indigo-700" },

    t('forget-your-password')))), /*#__PURE__*/




    React.createElement("div", { className: "pt-2" }, /*#__PURE__*/
    React.createElement("button", {
      type: "submit",
      disabled: loading,
      className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" },

    loading ? /*#__PURE__*/
    React.createElement("div", { className: "border-2 border-white/40 border-t-white w-5 h-5 rounded-full animate-spin" }) :

    t('sign-in')))));





}